export enum EnumTipoConfigGroupSign {
    CONFIGURACAO_CONDOMINIO = " Configuração por condomínio",
    CONFIGURACAO_DOCUMENTOS = "Configuração de documentos"
}